import { defineComponent as _defineComponent } from 'vue'
import {ref, computed, watch, onBeforeUpdate, onMounted} from 'vue'
import { Moment } from 'moment';
import { ISOTimeChunk, DayWithMomentChunk } from "./meeting-request-types";
import { useMeetingRequestSchedule } from "./schedule-mixin";

 
type Emits = {
    (e:'update:selectedChunk',time:DayWithMomentChunk):void,
    (e:'update:isAvailableTimes', value:boolean):void
}

type Props = {
    isAvailableTimes: boolean
}

type scrollEl = {
    element: HTMLElement,
    day: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'time-scroll',
  props: {
    isAvailableTimes: { type: Boolean }
  },
  emits: ["update:selectedChunk", "update:isAvailableTimes"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e:'update:selectedChunk',time:DayWithMomentChunk):void,
    (e:'update:isAvailableTimes', value:boolean):void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    isAvailableTimes: boolean
}

const {getNextDay, getPreviousDay, loadedDays, earliestDayLoaded, meetingDate,checkPreviousDay, formatDate} = useMeetingRequestSchedule(null);
const scrollableDays = ref<scrollEl[]>([]);
const oneDayLoaded = ref(true)
const lessThanFiveTimes = ref(false)
onMounted(()=>{
    checkUpArrow()   

})
onBeforeUpdate(()=>{
    scrollableDays.value = [];
})
watch(()=>scrollableDays.value, ()=>{
    // console.log("This",scrollableDays.value)
    scrollTo(meetingDate.value)
})

watch(()=>loadedDays, ()=>{
    // console.log("HIT WATCHER", loadedDays.value.length)
    if(loadedDays.value.length == 0 ){
        emit('update:isAvailableTimes',false)
    }else{
        emit('update:isAvailableTimes',true)
    }

    if(loadedDays.value.length < 2){
        if(loadedDays.value[0]){
            if(loadedDays.value[0].length <= 5){
                getNextDay()
            }
        }
    }
},{deep:true,immediate: true})



const firstTimeHovered = ref(false)
const isAPreviousDay = ref(checkPreviousDay())
const optionsAbove = ref(false)
const showArrow = ref(false)



const checkForFirstElement = (index: number, isHover: boolean) =>{
    if(index == 0){
        firstTimeHovered.value = isHover
    }
}

const checkUpArrow = () =>{
    if(isAPreviousDay.value){
        showArrow.value = true
    }else{
        if(optionsAbove.value){
            showArrow.value = true
        }
        showArrow.value = false
    }

}
const onScroll = () =>{
    let element = document.getElementById("scrollContainer")
    const scrollHeight = element?.scrollHeight
    const clientHeight = element?.clientHeight
    let scrollTop = element?.scrollTop;

    

    const percentage = scrollTop! / (scrollHeight! - clientHeight!) * 100

    const TOP_SCROLL_BUFFER = 60

    if(scrollTop! < TOP_SCROLL_BUFFER){
        optionsAbove.value = false
    }else{
        optionsAbove.value = true
    }
    isAPreviousDay.value = checkPreviousDay()
    checkUpArrow()

    if(percentage == 0){
        getPreviousDay()
      
    }
    if(Math.round(percentage) > 98){
        getNextDay()
    }
}
const setMeetingInfo = (time:DayWithMomentChunk) =>{
    emit('update:selectedChunk', time)
}



const __returned__ = { getNextDay, getPreviousDay, loadedDays, earliestDayLoaded, meetingDate, checkPreviousDay, formatDate, scrollableDays, oneDayLoaded, lessThanFiveTimes, props, emit, firstTimeHovered, isAPreviousDay, optionsAbove, showArrow, checkForFirstElement, checkUpArrow, onScroll, setMeetingInfo, ref, computed, watch, onBeforeUpdate, onMounted, Moment, ISOTimeChunk, DayWithMomentChunk, useMeetingRequestSchedule }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})